// Plain helpers for showing every organization a provider works at. No React in here, so the
// rules can be tested on their own.

const clean = (s) => (typeof s === "string" ? s.trim() : "");

/**
 * Organizations to show for a provider. The search API sends `organizations` (the main listing
 * first, then any extras). If it's missing (older backend, or a provider with none) fall back to
 * the single `groupName` every provider has always had, so the card never gets worse.
 */
export function organizationList(provider) {
  if (!provider) return [];
  if (Array.isArray(provider.organizations)) {
    const named = provider.organizations.filter((o) => clean(o && o.name));
    if (named.length > 0) return named;
  }
  const name = clean(provider.groupName);
  return name ? [{ name, primary: true }] : [];
}

export const organizationNames = (provider) => organizationList(provider).map((o) => clean(o.name));

export function locationLine(org) {
  return [org.addressLine1, org.city, org.state, org.zip].map(clean).filter(Boolean).join(", ");
}

// For the map popup, which is built as an HTML string. Organization names are typed in by an
// admin, so they must never be able to inject markup into the page.
export function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
